export const SKILLS = [
	{ title: 'HTML', percentages: 80, icon: 'html', viewDelay: 0.32 },
	{ title: 'CSS', percentages: 80, icon: 'css', viewDelay: 0.43 },
	{ title: 'JavaScript', percentages: 65, icon: 'js', viewDelay: 0.57 },
	{ title: 'React.js', percentages: 65, icon: 'react', viewDelay: 0.3 },
	{ title: 'Next.js', percentages: 50, icon: 'next', viewDelay: 0.5 },
	{ title: 'TypeScript', percentages: 50, icon: 'ts', viewDelay: 0.46 },
	{ title: 'Redux', percentages: 45, icon: 'redux', viewDelay: 0.62 },
	{ title: 'Npm', percentages: 50, icon: 'npm', viewDelay: 0.38 },
	{ title: 'Node.js', percentages: 35, icon: 'node', viewDelay: 0.76 },
	{ title: 'Webpack', percentages: 30, icon: 'webpack', viewDelay: 0.28 },
	{ title: 'Git', percentages: 60, icon: 'git', viewDelay: 0.5 },
	{ title: 'Sass', percentages: 80, icon: 'sass', viewDelay: 0.42 },
	{ title: 'BEM', percentages: 85, icon: 'bem', viewDelay: 0.52 },
	{ title: 'Axios', percentages: 70, icon: 'axios', viewDelay: 0.3 },
	{ title: 'MongoDB', percentages: 50, icon: 'mongo', viewDelay: 0.4 },
];
